import { render } from "./SportsCard.vue?vue&type=template&id=30b49065&scoped=true"
import script from "./SportsCard.vue?vue&type=script&lang=js"
export * from "./SportsCard.vue?vue&type=script&lang=js"

import "./SportsCard.vue?vue&type=style&index=0&id=30b49065&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b49065"]])

export default __exports__